import { render, staticRenderFns } from "./IotSensorListForm.vue?vue&type=template&id=c2072390&"
import script from "./IotSensorListForm.vue?vue&type=script&lang=js&"
export * from "./IotSensorListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports